module.exports = __webpack_public_path__ + "static/media/phone.0a44542d.png";